import React from 'react';
import { useSelector } from 'react-redux';
import Error from 'commons/src/components/errorComponents/Error';
import BuildInfo from 'commons/src/features/settingsPage/BuildInfo';
import LicenseSection from 'commons/src/features/settingsPage/LicensesSection';
import NewsletterSignUp from 'commons/src/features/settingsPage/NewsletterSignup';
import SecuritySettings from 'commons/src/features/settingsPage/security/SecuritySettings';
import UserInfo from 'commons/src/features/settingsPage/UserSettings/UserInfo';
import UserPreferences from 'commons/src/features/settingsPage/UserSettings/UserPreferences';
import { Store } from '../../reducers';

const BusinessAccountOverviewComponent = (): React.ReactElement => {
    const { error: appError } = useSelector((state: Store) => state.app);
    if (appError) {
        return <Error />;
    }

    return (
        <>
            <UserInfo />
            <UserPreferences />
            <NewsletterSignUp />
            <SecuritySettings />
            <LicenseSection />
            <BuildInfo />
        </>
    );
};

export default BusinessAccountOverviewComponent;
